import { Text, View, Image } from "@react-pdf/renderer";
import { styles } from "./ReactPdfStyles";
import QRCode from "../../assets/image/qr_img.png";

type ProjectDetailSectionTypes = {
	project_name: string;
	project_code: string;
	period: string;
	operator: string;
	location: string;
};

function ProjectDetailSection({ data }: { data: ProjectDetailSectionTypes }) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Project Detail</Text>

			<View style={styles.row}>
				<View style={{ width: "80%", flexDirection: "column" }}>
					<View style={styles.row}>
						<Text style={styles.labelCell}>Project title</Text>
						<Text style={styles.valueCell}>{data.project_name}</Text>
						<Text style={styles.labelCell}>Owner/Operator</Text>
						<Text style={styles.valueCell}>{data.operator}</Text>
					</View>

					<View style={styles.row}>
						<View style={{ flex: 2 }}>
							<View style={styles.row}>
								<Text style={styles.labelCell}>Project code</Text>
								<Text style={styles.valueCell}>{data.project_code}</Text>
							</View>
							<View style={styles.row}>
								<Text style={styles.labelCell}>Period</Text>
								<Text style={styles.valueCell}>{data.period}</Text>
							</View>
						</View>

						<View style={[styles.row, { flex: 2 }]}>
							<Text style={styles.labelCell}>Location</Text>
							<Text style={styles.valueCell}>{data.location}</Text>
						</View>
					</View>
				</View>

				<View style={styles.qrContainer}>
					<Image src={QRCode} style={styles.QRSize} />
					<Text style={{ fontSize: 8 }}>Scan/Click here to review data</Text>
				</View>
			</View>
		</View>
	);
}

export default ProjectDetailSection;
